import { Button } from '@synoptic/ui-kit/button/button.tsx';
import { WarningCircleIcon } from '@synoptic/ui-kit/icons/react/warning-circle.tsx';
import {
  ModalContent,
  ModalHeader,
  ModalRoot,
  ModalTitle,
  ModalTrigger,
} from '@synoptic/ui-kit/modal/modal.tsx';
import { FC, ReactNode, useState } from 'react';
import { deleteConfirmationActions } from '@/components/post-card/post-card-actions/post-card-actions-menu.css.ts';
import { submitAuthFormButton } from '@/routes/_auth/page.css.ts';

export type ReplaceUsernameModalProps = {
  trigger: ReactNode;
  link: string;
};

export const ReplaceUsernameModal: FC<ReplaceUsernameModalProps> = ({
  trigger,
  link,
}) => {
  const [open, onOpenChange] = useState(false);

  return (
    <ModalRoot open={open} onOpenChange={onOpenChange}>
      <ModalTrigger asChild>{trigger}</ModalTrigger>
      <ModalContent>
        <ModalHeader>
          <ModalTitle startIcon={<WarningCircleIcon />}>
            Replace username
          </ModalTitle>
        </ModalHeader>
        This will replace the current username
        <div className={deleteConfirmationActions}>
          <Button
            onClick={() => onOpenChange(false)}
            className={submitAuthFormButton}
            variant={'secondary'}
          >
            Skip for now
          </Button>
          <a href={link}>
            <Button className={submitAuthFormButton}>Connect X</Button>
          </a>
        </div>
      </ModalContent>
    </ModalRoot>
  );
};
